export default __webpack_public_path__ + "static/media/dp.91c4df08.jpg";